import React, { Component, Suspense } from "react";
import NumberFormat from "react-number-format";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ArrowLeft from "./../../../images/arrow.svg";
import IconJejakin from "./../../../images/icon-jejakin.png";
import Jaki from "./../../../images/jaki-cat.png";
// import ArrowRight from './../../../images/arrow-right.svg';
import "./CalculatorPage.scss";
import { Translation } from "react-i18next";

function debounce(func, wait, immediate) {
   var timeout;
   return function () {
      var context = this,
         args = arguments;
      var later = function () {
         timeout = null;
         if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
   };
}

class CalculatorPage extends Component {
   state = {
      status: true,
      statusLogin: false,
      statusUser: false,
      error: null,
      loading: true,
      calculating: false,
      active_calculating: null,
      result: true,
      step: 1,
      stepActive: 1,
      tree_name: "Mangrove",
      motorcycle_edit: false,
      motorcycle_km_lastest: 0,
      motorcycle_km: 0,
      car_edit: false,
      car_km_lastest: 0,
      car_km: 0,
      ac_hour_lastest: 0,
      ac_hour: 0,
      tv_hour_lastest: 0,
      tv_hour: 0,
      laptop_hour_lastest: 0,
      laptop_hour: 0,
      fridge_type: 0,
      fridge_type_latest: 0,
      motorcycle_carbon: 0,
      car_carbon: 0,
      tv_carbon: 0,
      laptop_carbon: 0,
      ac_carbon: 0,
      fridge_dropdown: false,
      fridge_carbon: 0,
      motorcycle_tree: 0,
      car_tree: 0,
      tv_tree: 0,
      laptop_tree: 0,
      ac_tree: 0,
      fridge_tree: 0,
      power_laptop: 61,
      power_tv: 60,
      power_ac: 315,
      total_km: 0,
      total_carbon: 0,
      total_tree: 0,
      equalsToTree: null,
      customDiv: ["div1"],
      selectedRadioAc: 0,
      selectedRadioTv: 0,
      selectedRadioLaptop: 0,
      selectedRadioFridge: 0,
      selectedRadioCar: 0,
      selectedRadioMotorcycle: 0,
      loaderVerify: false,
      isVerified: false,
      verify: false,
   };

   componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      const verify = query.get("verify");
      const tokenVerify = new String(verify);
      if (verify && tokenVerify.length > 200) {
         console.log("Verification..");
         this.verifyAccount(tokenVerify);
      }
   }
   goToStep = (step) => {
      this.setState({
         step: step,
      });
   };
   goToNextStep = () => {
      console.log("state is ", this.state.step);
      if (this.state.step < 6) {
         this.setState({
            step: this.state.step + 1,
         });
      } else if (this.state.step === 6 || this.state.step === "6") {
         setTimeout(() => {
            window.location.href =
               "/tree?total_carbon=" +
               this.state.total_carbon +
               "&total_tree=" +
               this.state.total_tree +
               "&motorcycle=" +
               this.state.motorcycle_km +
               "&car=" +
               this.state.car_km +
               "&ac_hour=" +
               this.state.ac_hour +
               "&tv_hour=" +
               this.state.tv_hour +
               "&laptop_hour=" +
               this.state.laptop_hour +
               "&fridge_type=" +
               this.state.fridge_type;
         }, 100);
      }
   };
   goToBack = () => {
      if (this.state.step === 1 || this.state.step === "1") {
         this.setState({
            step: 1,
         });
      } else {
         this.setState({
            step: this.state.step - 1,
         });
      }
   };

   calculateTotal = () => {
      console.log(
         `Total carbon is ${
            this.state.motorcycle_carbon +
            this.state.car_carbon +
            this.state.ac_carbon +
            this.state.tv_carbon +
            this.state.fridge_carbon +
            +this.state.laptop_carbon
         } and total tree is ${
            this.state.motorcycle_tree +
            this.state.car_tree +
            this.state.ac_tree +
            this.state.tv_tree +
            this.state.fridge_tree +
            this.state.laptop_tree
         } `
      );
      this.setState({
         total_carbon:
            this.state.motorcycle_carbon +
            this.state.car_carbon +
            this.state.ac_carbon +
            this.state.tv_carbon +
            this.state.fridge_carbon +
            this.state.laptop_carbon,
         total_tree:
            this.state.motorcycle_tree +
            this.state.car_tree +
            this.state.ac_tree +
            this.state.tv_tree +
            this.state.fridge_tree +
            this.state.laptop_tree,
      });
   };
   calculateCarbon = debounce((service, energyId, km) => {
      if (service === "car") {
         this.setState(
            { calculating: true, car_km_lastest: km, car_km: km },
            () => {
               this.getTotalCarbon(service, energyId, km, "input");
            }
         );
      } else {
         this.setState(
            { calculating: true, motorcycle_km_lastest: km, motorcycle_km: km },
            () => {
               this.getTotalCarbon(service, energyId, km, "input");
            }
         );
      }
   }, 1000);

   calculateCarbonElectricity = debounce((electricity, power, hour) => {
      console.log(
         `calculateCbElectricity: power is ${power} and hour is ${hour} and electricity is ${electricity}`
      );

      if (electricity === "tv") {
         this.setState(
            { calculating: true, tv_hour_lastest: hour, tv_hour: hour },
            () => {
               this.getTotalCarbonElectricity(
                  this.state.power_tv,
                  hour,
                  electricity,
                  "input"
               );
            }
         );
      } else if (electricity === "ac") {
         this.setState(
            { calculating: true, ac_hour_lastest: hour, ac_hour: hour },
            () => {
               this.getTotalCarbonElectricity(
                  this.state.power_ac,
                  hour,
                  electricity,
                  "input"
               );
            }
         );
      } else if (electricity === "laptop") {
         this.setState(
            { calculating: true, laptop_hour_lastest: hour, laptop_hour: hour },
            () => {
               this.getTotalCarbonElectricity(
                  this.state.power_laptop,
                  hour,
                  electricity,
                  "input"
               );
            }
         );
      } else {
         this.setState(
            { calculating: true, fridge_hour_lastest: hour, fridge_hour: hour },
            () => {
               this.getTotalCarbonElectricity(
                  power,
                  hour,
                  electricity,
                  "input"
               );
            }
         );
      }
   }, 1000);

   getTotalCarbon = (service, energyId, km, type) => {
      this.setState({ result: false });
      if (km <= 0) {
         console.log("distance km under 0 km, set zero", [`${service}_km`]);
         setTimeout(() => {
            this.setState(
               {
                  calculating: false,
                  result: true,
                  [`${service}_km`]: km,
                  [`${service}_carbon`]: 0,
                  [`${service}_tree`]: 0,
               },
               () => {
                  this.calculateTotal();
               }
            );
         }, 500);
      } else {
         axios({
            method: "GET",
            url:
               process.env.REACT_APP_API_HOST +
               "/calc-footprint?energyId=" +
               energyId +
               "&distance=" +
               km +
               "&person=1&unit=3&displayTree=true",
         }).then(
            (res) => {
               if (res.data.status) {
                  setTimeout(() => {
                     this.setState(
                        {
                           calculating: false,
                           result: true,
                           [`${service}_km`]: km,
                           [`${service}_carbon`]: res.data.data.totalCarbon,
                           [`${service}_tree`]: res.data.data.equalsToTreeValue,
                           equalsToTree: res.data.data.equalsToTree,
                        },
                        () => {
                           this.calculateTotal();
                        }
                     );
                  }, 500);
               } else {
                  setTimeout(() => {
                     this.setState({
                        calculating: false,
                        result: true,
                        total_carbon: null,
                        errorState: true,
                        errors: res.data.errors,
                     });
                  }, 1000);
               }
            },
            (error) => {
               setTimeout(() => {
                  this.setState({
                     calculating: false,
                     result: true,
                     total_carbon: null,
                     errorState: true,
                     errors: error.response.data.errors,
                  });
               }, 1000);
            }
         );
      }
   };

   getTotalCarbonElectricity = (power, hour, electricity, type) => {
      console.log(
         `getTotalCarbonElectricity : power is ${power} and hour is ${hour} and electricity is ${electricity}`
      );
      this.setState({ result: false });
      if (hour <= 0 || power <= 0) {
         setTimeout(() => {
            this.setState(
               {
                  calculating: false,
                  result: true,
                  [`${electricity}_hour`]: hour,
                  [`${electricity}_carbon`]: 0,
                  [`${electricity}_tree`]: 0,
               },
               () => {
                  this.calculateTotal();
               }
            );
         }, 500);
      } else {
         axios({
            method: "GET",
            url:
               process.env.REACT_APP_API_HOST +
               "/calc-footprint-electricity?power=" +
               power +
               "&hour=" +
               hour +
               "&unit=3",
         }).then(
            (res) => {
               if (res.data.status) {
                  setTimeout(() => {
                     this.setState(
                        {
                           calculating: false,
                           result: true,
                           [`${electricity}_hour`]: hour,
                           [`${electricity}_carbon`]: res.data.data.totalCarbon,
                           [`${electricity}_tree`]:
                              res.data.data.equalsToTreeValue,
                           equalsToTree: res.data.data.equalsToTree,
                        },
                        () => {
                           this.calculateTotal();
                        }
                     );
                  }, 500);
               } else {
                  setTimeout(() => {
                     this.setState({
                        calculating: false,
                        result: true,
                        total_carbon: null,
                        errorState: true,
                        errors: res.data.errors,
                     });
                  }, 1000);
               }
            },
            (error) => {
               setTimeout(() => {
                  this.setState({
                     calculating: false,
                     result: true,
                     total_carbon: null,
                     errorState: true,
                     errors: error.response.data.errors,
                  });
               }, 1000);
            }
         );
      }
   };

   verifyAccount = (token) => {
      this.setState({ loaderVerify: true });
      axios({
         method: "POST",
         url: process.env.REACT_APP_API_HOST + "/user/verify/" + token,
      }).then((response) => {
         // console.log("reponse data verify ", response.data);
         if (response.data.status === true) {
            this.setState({ verify: true });
         } else {
            setTimeout(() => {
               this.setState({ loaderVerify: false });
            }, 3000);
            if (response.data.error.length) {
               for (var er = 0; er < response.data.error.length; er++) {
                  var obj = response.data.error[er];
                  if (response.data.error[er].id === "UserMustNotVerified") {
                     this.setState({ isVerified: true });
                     toast.success(response.data.error);
                  } else {
                     for (var key in obj) {
                        console.log(key, obj[key]);
                        toast.error(key + " : " + obj[key]);
                     }
                  }
               }
            } else {
               toast.error(response.data.error);
            }
         }
      });
   };

   handleClickDistance = (service, distance) => {
      console.log(`click service is ${service} with distance ${distance}`);
      if (this.state.result) {
         if (service === "car") {
            if (distance !== 0) {
               this.setState({
                  selectedRadioCar: 0,
                  car_km: 0,
               });
            }
         } else if (service === "motorcycle") {
            if (distance !== 0) {
               this.setState({
                  selectedRadioMotorcycle: 0,
                  motorcycle_km: 0,
               });
            }
         } else if (service === "ac") {
            if (distance !== 0) {
               this.setState({
                  selectedRadioAc: 0,
                  ac_hour: 0,
               });
            }
         } else if (service === "tv") {
            if (distance !== 0) {
               this.setState({
                  selectedRadioTv: 0,
                  tv_hour: 0,
               });
            }
         } else {
            if (distance !== 0) {
               this.setState({
                  selectedRadioFridge: 0,
                  fridge_type: 0,
               });
            }
         }
      }
   };

   handleChangeDistance = (service, energy, distance) => {
      console.log(`change service is ${service} with distance ${distance}`);
      this.setState({ result: false });
      if (service === "car") {
         this.setState({
            car_km: parseInt(distance),
            selectedRadioCar: parseInt(distance),
         });
      } else if (service === "motorcycle") {
         this.setState({
            selectedRadioMotorcycle: parseInt(distance),
            motorcycle_km: parseInt(distance),
         });
      } else if (service === "ac") {
         this.setState({
            selectedRadioAc: parseInt(distance),
            ac_hour: parseInt(distance),
         });
      } else if (service === "tv") {
         this.setState({
            selectedRadioTv: parseInt(distance),
            tv_hour: parseInt(distance),
         });
      } else {
         this.setState(
            {
               selectedRadioFridge: parseInt(distance),
               fridge_type: parseInt(distance),
            },
            () => {
               this.setState({
                  fridge_dropdown: false,
               });
            }
         );
      }
   };

   render() {
      return (
         <div className="calculator-app">
            <ToastContainer />
            
            
            <Suspense fallback={"...Loading"}>
               <Translation>
                  {(t, { i18n }) => (
                     <div className="calculator-container">
                        {this.state.loaderVerify ? (
                           <div>
                              {this.state.verify === true ? (
                                 <div className="wrapper-banner text-center box-verify success">
                                    <i className="fa fa-check"></i>
                                    <br />
                                    <span>{t("verifysuccess")}</span>
                                 </div>
                              ) : (
                                 <div className="box-verify text-center mb-4">
                                    <span>
                                       <div
                                          className="loader"
                                          style={{
                                             borderColor: "#00880d",
                                             borderTopColor: "#ddd",
                                             margin: "auto",
                                          }}
                                       ></div>
                                       <br />
                                       <br />
                                       <small>{t("verifyaccount")}</small>
                                    </span>
                                    <br />
                                 </div>
                              )}
                           </div>
                        ) : null}
                        <div className="calculator">
                           <div className="cs-step">
                              <div
                                 className="cs-step-arrow"
                                 style={{ cursor: "pointer" }}
                                 onClick={() => {
                                    this.goToBack();
                                 }}
                              >
                                 {this.state.step === 1 ? (
                                    <img
                                       src={IconJejakin}
                                       className="logo"
                                       alt="Jejakin"
                                    />
                                 ) : (
                                    <img src={ArrowLeft} alt="Back" />
                                 )}
                              </div>
                              <div className="cs-step-wizard">
                                 <React.Fragment>
                                    <div className="count">
                                       <span
                                          className="count-text"
                                          style={{ paddingLeft: "0" }}
                                       >
                                          Jejak.in - {t("Carbon Calculator")}
                                       </span>
                                       <div className="info">
                                          #SavingOurTomorrow
                                       </div>
                                    </div>
                                 </React.Fragment>
                              </div>
                           </div>
                           {this.state.step < 6 ? (
                              <div className="cs-emission">
                                 <span
                                    className={`cse-item ${
                                       this.state.step === 1 ? "active" : null
                                    } ${this.state.step > 1 ? "done" : null}`}
                                    onClick={() => {
                                       this.goToStep(1);
                                    }}
                                 >
                                    🚘 {t("Car")} &amp; {t("Motorcycle")}
                                 </span>
                                 <span
                                    className={`cse-item ${
                                       this.state.step === 2 ? "active" : null
                                    } ${this.state.step > 2 ? "done" : null}`}
                                    onClick={() => {
                                       this.goToStep(2);
                                    }}
                                 >
                                    ❄️ {t("AC")}
                                 </span>
                                 <span
                                    className={`cse-item ${
                                       this.state.step === 3 ? "active" : null
                                    } ${this.state.step > 3 ? "done" : null}`}
                                    onClick={() => {
                                       this.goToStep(3);
                                    }}
                                 >
                                    📺 {t("TV")}
                                 </span>
                                 <span
                                    className={`cse-item ${
                                       this.state.step === 4 ? "active" : null
                                    } ${this.state.step > 4 ? "done" : null}`}
                                    onClick={() => {
                                       this.goToStep(4);
                                    }}
                                 >
                                    💻 {t("Laptop")}
                                 </span>
                                 <span
                                    className={`cse-item ${
                                       this.state.step === 5 ? "active" : null
                                    } ${this.state.step > 5 ? "done" : null}`}
                                    onClick={() => {
                                       this.goToStep(5);
                                    }}
                                 >
                                    ❄️ {t("Fridge")}
                                 </span>
                              </div>
                           ) : null}
                           <div
                              className={`cs-select cs-select-${this.state.step}`}
                           >
                              {this.state.step === 1 ? (
                                 <div
                                    className={`calc-form calc-car calc-form-${this.state.step}`}
                                 >
                                    <div className="row">
                                       <div className="col-12">
                                          <div className="calc-card">
                                             <div className="mb-10">
                                                <label
                                                   className="label-group"
                                                   htmlFor="inputmotorcycle"
                                                >
                                                   {t(
                                                      "AverageDistancePerDayWithMotorcycle"
                                                   )}
                                                </label>
                                             </div>
                                             <div className="mb-0">
                                                {this.state.calculating &&
                                                this.state
                                                   .active_calculating !==
                                                   "motorcycle" ? (
                                                   <NumberFormat
                                                      id="inputmotorcycle"
                                                      displayType={"input"}
                                                      placeholder={t(
                                                         "TypeHere"
                                                      )}
                                                      thousandSeparator={"."}
                                                      decimalSeparator={","}
                                                      decimalScale={0}
                                                      allowNegative={false}
                                                      suffix={" km"}
                                                      onValueChange={(e) =>
                                                         this.calculateCarbon(
                                                            "motorcycle",
                                                            "8",
                                                            e.value
                                                         )
                                                      }
                                                      isAllowed={(values) => {
                                                         const {
                                                            formattedValue,
                                                            floatValue,
                                                         } = values;
                                                         return (
                                                            formattedValue ===
                                                               "" ||
                                                            floatValue <= 99
                                                         );
                                                      }}
                                                      onClick={() => {
                                                         this.setState({
                                                            selectedRadioMotorcycle: 0,
                                                         });
                                                      }}
                                                      className={
                                                         this.state
                                                            .selectedRadioMotorcycle
                                                            ? "radioActive"
                                                            : "inputActive"
                                                      }
                                                      value={
                                                         this.state
                                                            .motorcycle_km || ""
                                                      }
                                                      disabled
                                                   />
                                                ) : (
                                                   <NumberFormat
                                                      id="inputmotorcycle"
                                                      displayType={"input"}
                                                      placeholder={t(
                                                         "TypeHere"
                                                      )}
                                                      thousandSeparator={"."}
                                                      decimalSeparator={","}
                                                      decimalScale={0}
                                                      allowNegative={false}
                                                      suffix={" km"}
                                                      onValueChange={(e) => {
                                                         this.setState(
                                                            {
                                                               active_calculating:
                                                                  "motorcycle",
                                                               calculating: true,
                                                               motorcycle_km:
                                                                  e.value,
                                                               motorcycle_km_lastest:
                                                                  e.value,
                                                            },
                                                            () =>
                                                               this.calculateCarbon(
                                                                  "motorcycle",
                                                                  "8",
                                                                  e.value
                                                               )
                                                         );
                                                      }}
                                                      isAllowed={(values) => {
                                                         const {
                                                            formattedValue,
                                                            floatValue,
                                                         } = values;
                                                         return (
                                                            formattedValue ===
                                                               "" ||
                                                            floatValue <= 99
                                                         );
                                                      }}
                                                      onClick={() => {
                                                         this.setState({
                                                            selectedRadioMotorcycle: 0,
                                                         });
                                                      }}
                                                      className={
                                                         this.state
                                                            .selectedRadioMotorcycle
                                                            ? "radioActive"
                                                            : "inputActive"
                                                      }
                                                      value={
                                                         this.state
                                                            .motorcycle_km || ""
                                                      }
                                                   />
                                                )}
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-12">
                                          <div className="calc-card">
                                             <div className="mb-10">
                                                <label
                                                   className="label-group"
                                                   htmlFor="inputcar"
                                                >
                                                   {t(
                                                      "AverageDistancePerDayWithCar"
                                                   )}
                                                </label>
                                             </div>
                                             <div className="mb-0">
                                                {this.state.calculating &&
                                                this.state
                                                   .active_calculating !==
                                                   "car" ? (
                                                   <NumberFormat
                                                      id="inputcar"
                                                      displayType={"input"}
                                                      placeholder={t(
                                                         "TypeHere"
                                                      )}
                                                      thousandSeparator={"."}
                                                      decimalSeparator={","}
                                                      decimalScale={0}
                                                      allowNegative={false}
                                                      suffix={" km"}
                                                      onValueChange={(e) =>
                                                         this.calculateCarbon(
                                                            "car",
                                                            "1",
                                                            e.value
                                                         )
                                                      }
                                                      isAllowed={(values) => {
                                                         const {
                                                            formattedValue,
                                                            floatValue,
                                                         } = values;
                                                         return (
                                                            formattedValue ===
                                                               "" ||
                                                            floatValue <= 99
                                                         );
                                                      }}
                                                      onClick={() => {
                                                         this.setState({
                                                            selectedRadioCar: 0,
                                                         });
                                                      }}
                                                      className={
                                                         this.state
                                                            .selectedRadioCar
                                                            ? "radioActive"
                                                            : "inputActive"
                                                      }
                                                      value={
                                                         this.state.car_km || ""
                                                      }
                                                      disabled
                                                   />
                                                ) : (
                                                   <NumberFormat
                                                      id="inputcar"
                                                      displayType={"input"}
                                                      placeholder={t(
                                                         "TypeHere"
                                                      )}
                                                      thousandSeparator={"."}
                                                      decimalSeparator={","}
                                                      decimalScale={0}
                                                      allowNegative={false}
                                                      suffix={" km"}
                                                      onValueChange={(e) => {
                                                         this.setState(
                                                            {
                                                               active_calculating:
                                                                  "car",
                                                               calculating: true,
                                                               car_km: e.value,
                                                               car_km_lastest:
                                                                  e.value,
                                                            },
                                                            () =>
                                                               this.calculateCarbon(
                                                                  "car",
                                                                  "1",
                                                                  e.value
                                                               )
                                                         );
                                                      }}
                                                      isAllowed={(values) => {
                                                         const {
                                                            formattedValue,
                                                            floatValue,
                                                         } = values;
                                                         return (
                                                            formattedValue ===
                                                               "" ||
                                                            floatValue <= 99
                                                         );
                                                      }}
                                                      onClick={() => {
                                                         this.setState({
                                                            selectedRadioCar: 0,
                                                         });
                                                      }}
                                                      className={
                                                         this.state
                                                            .selectedRadioCar
                                                            ? "radioActive"
                                                            : "inputActive"
                                                      }
                                                      value={
                                                         this.state.car_km || ""
                                                      }
                                                   />
                                                )}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              ) : null}
                              {this.state.step === 2 ? (
                                 <div
                                    className={`calc-form calc-ac calc-form-${this.state.step}`}
                                 >
                                    <div className="calc-card">
                                       <div className="mb-10">
                                          <label
                                             className="label-group"
                                             htmlFor="inputac"
                                          >
                                             {t("AverageHourPerDayUsingAc")}
                                          </label>
                                       </div>
                                       <div className="mb-0">
                                          {this.state.calculating &&
                                          this.state.active_calculating !==
                                             "ac" ? (
                                             <NumberFormat
                                                id="inputac"
                                                displayType={"input"}
                                                placeholder={t("TypeHere")}
                                                thousandSeparator={"."}
                                                decimalSeparator={","}
                                                decimalScale={0}
                                                allowNegative={false}
                                                suffix={" " + t("hours")}
                                                onValueChange={(e) =>
                                                   this.calculateCarbonElectricity(
                                                      "ac",
                                                      this.state.power_ac,
                                                      e.value
                                                   )
                                                }
                                                isAllowed={(values) => {
                                                   const {
                                                      formattedValue,
                                                      floatValue,
                                                   } = values;
                                                   return (
                                                      formattedValue === "" ||
                                                      floatValue <= 24
                                                   );
                                                }}
                                                onClick={() => {
                                                   this.setState({
                                                      selectedRadioAc: 0,
                                                   });
                                                }}
                                                className={
                                                   this.state.selectedRadioAc
                                                      ? "radioActive"
                                                      : "inputActive"
                                                }
                                                value={this.state.ac_hour || ""}
                                                disabled
                                             />
                                          ) : (
                                             <NumberFormat
                                                id="inputac"
                                                displayType={"input"}
                                                placeholder={t("TypeHere")}
                                                thousandSeparator={"."}
                                                decimalSeparator={","}
                                                decimalScale={0}
                                                allowNegative={false}
                                                suffix={" " + t("hours")}
                                                onValueChange={(e) => {
                                                   this.setState(
                                                      {
                                                         active_calculating:
                                                            "ac",
                                                         calculating: true,
                                                         ac_hour: e.value,
                                                         ac_hour_lastest:
                                                            e.value,
                                                      },
                                                      () =>
                                                         this.calculateCarbonElectricity(
                                                            "ac",
                                                            this.state.power_ac,
                                                            e.value
                                                         )
                                                   );
                                                }}
                                                isAllowed={(values) => {
                                                   const {
                                                      formattedValue,
                                                      floatValue,
                                                   } = values;
                                                   return (
                                                      formattedValue === "" ||
                                                      floatValue <= 24
                                                   );
                                                }}
                                                onClick={() => {
                                                   this.setState({
                                                      selectedRadioAc: 0,
                                                   });
                                                }}
                                                className={
                                                   this.state.selectedRadioAc
                                                      ? "radioActive"
                                                      : "inputActive"
                                                }
                                                value={this.state.ac_hour || ""}
                                             />
                                          )}
                                       </div>
                                    </div>
                                 </div>
                              ) : null}
                              {this.state.step === 3 ? (
                                 <div
                                    className={`calc-form calc-tv calc-form-${this.state.step}`}
                                 >
                                    <div className="calc-card">
                                       <div className="mb-10">
                                          <label
                                             className="label-group"
                                             htmlFor="inputtv"
                                          >
                                             {t("AverageHourPerDayUsingTv")}
                                          </label>
                                       </div>
                                       <div className="mb-0">
                                          {this.state.calculating &&
                                          this.state.active_calculating !==
                                             "tv" ? (
                                             <NumberFormat
                                                id="inputtv"
                                                displayType={"input"}
                                                placeholder={t("TypeHere")}
                                                thousandSeparator={"."}
                                                decimalSeparator={","}
                                                decimalScale={0}
                                                allowNegative={false}
                                                suffix={" " + t("hours")}
                                                onValueChange={(e) =>
                                                   this.calculateCarbonElectricity(
                                                      "tv",
                                                      this.state.power_tv,
                                                      e.value
                                                   )
                                                }
                                                isAllowed={(values) => {
                                                   const {
                                                      formattedValue,
                                                      floatValue,
                                                   } = values;
                                                   return (
                                                      formattedValue === "" ||
                                                      floatValue <= 24
                                                   );
                                                }}
                                                onClick={() => {
                                                   this.setState({
                                                      selectedRadioTv: 0,
                                                   });
                                                }}
                                                className={
                                                   this.state.selectedRadioTv
                                                      ? "radioActive"
                                                      : "inputActive"
                                                }
                                                value={this.state.tv_hour || ""}
                                                disabled
                                             />
                                          ) : (
                                             <NumberFormat
                                                id="inputtv"
                                                displayType={"input"}
                                                placeholder={t("TypeHere")}
                                                thousandSeparator={"."}
                                                decimalSeparator={","}
                                                decimalScale={0}
                                                allowNegative={false}
                                                suffix={" " + t("hours")}
                                                onValueChange={(e) => {
                                                   this.setState(
                                                      {
                                                         active_calculating:
                                                            "tv",
                                                         calculating: true,
                                                         tv_hour: e.value,
                                                         tv_hour_lastest:
                                                            e.value,
                                                      },
                                                      () =>
                                                         this.calculateCarbonElectricity(
                                                            "tv",
                                                            this.state.power_tv,
                                                            e.value
                                                         )
                                                   );
                                                }}
                                                isAllowed={(values) => {
                                                   const {
                                                      formattedValue,
                                                      floatValue,
                                                   } = values;
                                                   return (
                                                      formattedValue === "" ||
                                                      floatValue <= 24
                                                   );
                                                }}
                                                onClick={() => {
                                                   this.setState({
                                                      selectedRadioTv: 0,
                                                   });
                                                }}
                                                className={
                                                   this.state.selectedRadioTv
                                                      ? "radioActive"
                                                      : "inputActive"
                                                }
                                                value={this.state.tv_hour || ""}
                                             />
                                          )}
                                       </div>
                                    </div>
                                 </div>
                              ) : null}
                              {this.state.step === 4 ? (
                                 <div
                                    className={`calc-form calc-laptop calc-form-${this.state.step}`}
                                 >
                                    <div className="calc-card">
                                       <div className="mb-10">
                                          <label
                                             className="label-group"
                                             htmlFor="inputlaptop"
                                          >
                                             {t("AverageHourPerDayUsingLaptop")}
                                          </label>
                                       </div>
                                       <div className="mb-0">
                                          {this.state.calculating &&
                                          this.state.active_calculating !==
                                             "laptop" ? (
                                             <NumberFormat
                                                id="inputlaptop"
                                                displayType={"input"}
                                                placeholder={t("TypeHere")}
                                                thousandSeparator={"."}
                                                decimalSeparator={","}
                                                decimalScale={0}
                                                allowNegative={false}
                                                suffix={" " + t("hours")}
                                                onValueChange={(e) =>
                                                   this.calculateCarbonElectricity(
                                                      "laptop",
                                                      this.state.power_laptop,
                                                      e.value
                                                   )
                                                }
                                                isAllowed={(values) => {
                                                   const {
                                                      formattedValue,
                                                      floatValue,
                                                   } = values;
                                                   return (
                                                      formattedValue === "" ||
                                                      floatValue <= 24
                                                   );
                                                }}
                                                onClick={() => {
                                                   this.setState({
                                                      selectedRadioLaptop: 0,
                                                   });
                                                }}
                                                className={
                                                   this.state
                                                      .selectedRadioLaptop
                                                      ? "radioActive"
                                                      : "inputActive"
                                                }
                                                value={
                                                   this.state.laptop_hour || ""
                                                }
                                                disabled
                                             />
                                          ) : (
                                             <NumberFormat
                                                id="inputlaptop"
                                                displayType={"input"}
                                                placeholder={t("TypeHere")}
                                                thousandSeparator={"."}
                                                decimalSeparator={","}
                                                decimalScale={0}
                                                allowNegative={false}
                                                suffix={" " + t("hours")}
                                                onValueChange={(e) => {
                                                   this.setState(
                                                      {
                                                         active_calculating:
                                                            "laptop",
                                                         calculating: true,
                                                         laptop_hour: e.value,
                                                         laptop_hour_lastest:
                                                            e.value,
                                                      },
                                                      () =>
                                                         this.calculateCarbonElectricity(
                                                            "laptop",
                                                            this.state
                                                               .power_laptop,
                                                            e.value
                                                         )
                                                   );
                                                }}
                                                isAllowed={(values) => {
                                                   const {
                                                      formattedValue,
                                                      floatValue,
                                                   } = values;
                                                   return (
                                                      formattedValue === "" ||
                                                      floatValue <= 24
                                                   );
                                                }}
                                                onClick={() => {
                                                   this.setState({
                                                      selectedRadioLaptop: 0,
                                                   });
                                                }}
                                                className={
                                                   this.state
                                                      .selectedRadioLaptop
                                                      ? "radioActive"
                                                      : "inputActive"
                                                }
                                                value={
                                                   this.state.laptop_hour || ""
                                                }
                                             />
                                          )}
                                       </div>
                                    </div>
                                 </div>
                              ) : null}
                              {this.state.step === 5 ? (
                                 <div
                                    className={`calc-form calc-fridge calc-form-${this.state.step}`}
                                 >
                                    <div className="calc-card">
                                       <div className="mb-10">
                                          <label
                                             className="label-group"
                                             htmlFor="inputfridge"
                                          >
                                             {t("FridgeStorageCapacity")}
                                          </label>
                                       </div>
                                       <div className="mb-0">
                                          <NumberFormat
                                             id="inputfridge"
                                             displayType={"input"}
                                             placeholder={t("TypeHere")}
                                             thousandSeparator={"."}
                                             decimalSeparator={","}
                                             decimalScale={0}
                                             allowNegative={false}
                                             suffix={" " + t("watt")}
                                             onValueChange={(e) =>
                                                this.calculateCarbonElectricity(
                                                   "fridge",
                                                   this.state.fridge_type,
                                                   24
                                                )
                                             }
                                             isAllowed={(values) => {
                                                const {
                                                   formattedValue,
                                                   floatValue,
                                                } = values;
                                                return (
                                                   formattedValue === "" ||
                                                   floatValue <= 1
                                                );
                                             }}
                                             onClick={() => {
                                                this.setState({
                                                   selectedRadioFridge: 0,
                                                });
                                             }}
                                             className={
                                                this.state.selectedRadioFridge
                                                   ? "radioActive"
                                                   : "inputActive"
                                             }
                                             value={
                                                this.state.fridge_type || ""
                                             }
                                             style={{ display: "none" }}
                                          />
                                          <div
                                             className={
                                                this.state.fridge_dropdown
                                                   ? "row opction-select"
                                                   : "row option-select"
                                             }
                                          >
                                             <div className="col-4">
                                                <div
                                                   className={`${
                                                      this.state.fridge_type ===
                                                      60
                                                         ? "is-item active"
                                                         : "is-item"
                                                   }`}
                                                   onClick={() => {
                                                      this.handleChangeDistance(
                                                         "fridge",
                                                         "60",
                                                         "60"
                                                      );
                                                   }}
                                                >
                                                   1 <br />
                                                   {t("door")}
                                                </div>
                                             </div>
                                             <div className="col-4">
                                                <div
                                                   className={`${
                                                      this.state.fridge_type ===
                                                      70
                                                         ? "is-item active"
                                                         : "is-item"
                                                   }`}
                                                   onClick={() => {
                                                      this.handleChangeDistance(
                                                         "fridge",
                                                         "70",
                                                         "70"
                                                      );
                                                   }}
                                                >
                                                   2 <br />
                                                   {t("doors")}
                                                </div>
                                             </div>
                                             <div className="col-4">
                                                <div
                                                   className={`${
                                                      this.state.fridge_type ===
                                                      170
                                                         ? "is-item active"
                                                         : "is-item"
                                                   }`}
                                                   onClick={() => {
                                                      this.handleChangeDistance(
                                                         "fridge",
                                                         "170",
                                                         "170"
                                                      );
                                                   }}
                                                >
                                                   3 <br />
                                                   {t("doors")}
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              ) : null}
                              {this.state.step === 6 ? (
                                 <>
                                    <div className="box-calc-emission">
                                       <span>
                                          {t("YourTotalCarbonFootprint")}
                                       </span>
                                       <img src={Jaki} alt="Jejakin" />
                                       {this.state.result === true ? (
                                          <h2 className="mb-0">
                                             {this.state.lang === "id" ? (
                                                <React.Fragment>
                                                   <NumberFormat
                                                      value={
                                                         this.state.total_carbon
                                                      }
                                                      displayType={"text"}
                                                      thousandSeparator={"."}
                                                      decimalSeparator={","}
                                                      decimalScale={0}
                                                   />{" "}
                                                   gram
                                                </React.Fragment>
                                             ) : (
                                                <React.Fragment>
                                                   <NumberFormat
                                                      value={
                                                         this.state.total_carbon
                                                      }
                                                      displayType={"text"}
                                                      thousandSeparator={","}
                                                      decimalSeparator={"."}
                                                      decimalScale={0}
                                                   />{" "}
                                                   grams
                                                </React.Fragment>
                                             )}
                                          </h2>
                                       ) : (
                                          <h2 className="mb-0">
                                             <div className="loader loader-calc"></div>
                                          </h2>
                                       )}
                                    </div>
                                    <div className="box-calculation">
                                       <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                       >
                                          <path
                                             fillRule="evenodd"
                                             clipRule="evenodd"
                                             d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM11 7H13V9H11V7ZM13 11H11L11 17H13L13 11Z"
                                             fill="#3BA749"
                                          />
                                       </svg>
                                       <p>{t("InfoCalculation")}</p>
                                    </div>
                                 </>
                              ) : null}
                           </div>
                        </div>
                        <div className="footer-calc">
                           {this.state.step < 5 ? (
                              <button
                                 className="btn btn-green btn-block"
                                 onClick={() => {
                                    this.goToNextStep();
                                 }}
                              >
                                 {t("Next")}
                              </button>
                           ) : null}
                           {this.state.step === 5 ? (
                              <>
                                 {this.state.total_carbon > 0 ? (
                                    <button
                                       className="btn btn-green btn-block"
                                       onClick={() => {
                                          this.goToNextStep();
                                       }}
                                    >
                                       {t("CalculateYourFootprint")}
                                    </button>
                                 ) : (
                                    <button
                                       className="btn btn-green btn-block"
                                       disabled
                                    >
                                       {t("CalculateYourFootprint")}
                                    </button>
                                 )}
                              </>
                           ) : null}
                           {this.state.step === 6 ? (
                              <button
                                 className="btn btn-green btn-block"
                                 onClick={() => {
                                    this.goToNextStep();
                                 }}
                              >
                                 {t("OffsetYourCarbon")}
                              </button>
                           ) : null}
                           {this.state.step === 7 ? (
                              <button className="btn btn-green btn-block">
                                 <div className="loader"></div>
                              </button>
                           ) : null}
                        </div>
                     </div>
                  )}
               </Translation>
            </Suspense>
         </div>
      );
   }
}

export default CalculatorPage;
